export const chartDays = [
    {
      label: "24 Hours",
      value: 1,
    },
    {
      label: "30 Days",
      value: 30,
    },
    {
      label: "3 Mos",
      value: 90,
    },
    {
      label: "1 Yr",
      value: 365,
    },
  ];